import { TFunction } from 'client/i18n/hooks/useT';

export function getFAQ(t: TFunction) {
  return [
    {
      question: t(
        'AdsByAnchorScreen.FAQ.MonetizationQuestion',
        'When is monetization expanding beyond the U.S.?',
        'Ads by Anchor page, FAQ section monetization question'
      ),
      answer: t(
        'AdsByAnchorScreen.FAQ.MonetizationAnswer',
        'We are currently working on unlocking this option for our global creators and will have more to share in 2022.',
        'Ads by Anchor page, FAQ section monetization answer'
      ),
    },
    {
      question: t(
        'AdsByAnchorScreen.FAQ.EarningQuestion',
        "When do I know how much I'll earn with each Ads by Anchor option?",
        'Ads by Anchor page, FAQ section gains from ads question'
      ),
      answer: t(
        'AdsByAnchorScreen.FAQ.EarningAnswer',
        'Each option has a slightly different pricing model that will determine how much you earn. You will be shown the price for each option before you accept it.',
        'Ads by Anchor page, FAQ section gains from ads answer'
      ),
    },
    {
      question: t(
        'AdsByAnchorScreen.FAQ.HostingQuestion',
        "I'm not currently hosted on Anchor. Can I still use your monetization tools?",
        'Ads by Anchor page, FAQ section hosting question'
      ),
      answer: t(
        'AdsByAnchorScreen.FAQ.HostingAnswer',
        "Your podcast must be hosted on Anchor to take advantage of Anchor's monetization tools.",
        'Ads by Anchor page, FAQ section hosting answer'
      ),
    },
    {
      question: t(
        'AdsByAnchorScreen.FAQ.AdsPlaybackQuestion',
        'Will the ads play beyond Spotify?',
        'Ads by Anchor page, FAQ section ads playback question'
      ),
      answer: t(
        'AdsByAnchorScreen.FAQ.AdsPlaybackAnswer',
        "Yes, Ads by Anchor can play on and beyond Spotify. Ads served to listeners on Spotify will be delivered via Spotify's proprietary Streaming Ad Insertion technology, which enables the most precise and transparent podcast advertising in the industry.",
        'Ads by Anchor page, FAQ section ads playback answer'
      ),
    },
    {
      question: t(
        'AdsByAnchorScreen.FAQ.MonetizationToolsQuestion',
        'Can I use multiple monetization tools at the same time?',
        'Ads by Anchor page, FAQ section monetization tools question'
      ),
      answer: t(
        'AdsByAnchorScreen.FAQ.MonetizationToolsAnswer',
        'Creators are free to choose how many ads, and which types (based on which they qualify for), to include in their episodes, to maximize their earning potential. However, we recommend that you not include ads in episodes for your paid subscribers.',
        'Ads by Anchor page, FAQ section monetization tools answer'
      ),
    },
    {
      question: t(
        'AdsByAnchorScreen.FAQ.AdsOptionsQuestion',
        'How will I know when I qualify for different Ads by Anchor options?',
        'Ads by Anchor page, FAQ section ads options question'
      ),
      answer: t(
        'AdsByAnchorScreen.FAQ.AdsOptionsAnswer',
        "Check the 'Money' page on Anchor to see the different Ads by Anchor options and which you qualify to use.",
        'Ads by Anchor page, FAQ section ads options answer'
      ),
    },
  ];
}
